import { render, staticRenderFns } from "./ProductSummary.vue?vue&type=template&id=3a3ef2d0&"
import script from "./ProductSummary.vue?vue&type=script&lang=ts&"
export * from "./ProductSummary.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./ProductSummary.vue?vue&type=custom&index=0&blockType=styles&lang=scss&scoped=true"
if (typeof block0 === 'function') block0(component)

export default component.exports